import { ReactNode } from 'react';

export default ({ children }: { children: ReactNode }) => (
  <ul className="naked-list">{children}</ul>
);
